// extracted by css-extract-rspack-plugin
export default {"cls1":"ActiveState-cls1_XD1","cls2":"ActiveState-cls2_uxo ActiveState-cls1_XD1","isMobile":"ActiveState-isMobile_XrB"};